module.exports = __webpack_public_path__ + "media/images/how-it-works/directduel/step-1-b78096b987d9296513bba87773ed189f.png";